<template lang="pug">
div
  LoaderOverlay(:loading="loading")
    form
      .row
        .col-md-6
          .form-group
            Label(text="Name")
            Input(v-model="apiClientStore.apiClient.name")

          // There is no point in showing a dilabled checkbox on initial create
          .form-group(v-if="apiClientStore.apiClient.id")
            LabelledCheckbox(label="Disabled" v-model="apiClientStore.apiClient.disabled")

      .row
        .col-md-12
          button.btn.btn-primary(@click.prevent="save") Save
          router-link.btn.btn-link.text-muted(to="/admin/api_clients/") cancel
</template>

<script>
  import { mapStores } from 'pinia'
  import { useApiClientStore } from '@/stores/api_client'

  import LabelledCheckbox from '@/components/shared/labelled_checkbox.vue'
  import Input from '@/components/shared/input.vue'
  import Label from '@/components/shared/label.vue'
  import LoaderOverlay from '@/components/shared/loader_overlay.vue'

  export default {
    components: {
      LabelledCheckbox,
      Input,
      Label,
      LoaderOverlay
    },

    data() {
      return {
        loading: false
      }
    },

    computed: {
      ...mapStores(useApiClientStore)
    },

    methods: {
      async save() {
        this.loading = true

        await this.apiClientStore.save()

        this.loading = false
        this.$router.push('/admin/api_clients/')
      }
    },
  }
</script>
